export class Role {
  public name: string;
  public friendlyName: string;
  public accessBits: string;
  public category: string;
  public accessLevel: number;

  constructor(role: Partial<Role>) {
    if (role.name == null)
      throw new Error(
        `Invalid role in constructor: ${JSON.stringify(role)}\n namespace cannot be null`,
      );
    if (role.accessBits == null)
      throw new Error(
        `Invalid role in constructor: ${JSON.stringify(role)}\n accessbits cannot be null`,
      );
    if (role.accessLevel == null) {
      throw new Error(
        `Invalid role in construtor: ${JSON.stringify(role)}\n accessLevel cannot be null`,
      );
    }
    if (role.category == null) {
      throw new Error(
        `Invalid role in construtor: ${JSON.stringify(role)}\n category cannot be null`,
      );
    }

    // TODO: this should be tightened up once all roles have a friendly name assigned
    if (!role.friendlyName || role.friendlyName == '') {
      this.friendlyName = role.name;
    } else {
      this.friendlyName = role.friendlyName;
    }

    this.name = role.name;
    this.accessBits = role.accessBits;
    this.accessLevel = role.accessLevel;
    this.category = role.category;
  }

  static createEmpty(): Partial<Role> {
    return {
      name: '',
      friendlyName: '',
      accessBits: '',
      category: '',
      accessLevel: 0,
    };
  }

  public static copy(roleToCopy: Partial<Role>): Partial<Role> {
    let newRole = Role.createEmpty();

    if (roleToCopy) {
      newRole.accessBits = roleToCopy.accessBits;
      newRole.accessLevel = roleToCopy.accessLevel;
      newRole.category = roleToCopy.category;
      newRole.friendlyName = roleToCopy.friendlyName;
      newRole.name = roleToCopy.name;
    }

    return newRole;
  }
}
